module.exports = __webpack_public_path__ + "img/Flag_of_Aruba.b301257d.svg";